import React from 'react';

import { Piwik, SiteCoreDictionary } from '@eika-kortbetjening/types';
import { Button, ButtonTypes } from '@eika/button';

type DigitalCardAndPinProps = {
    dictionary: SiteCoreDictionary;
    isMobile: boolean;
    onDigitalCardClick: (() => void) | undefined;
    onSeePinClick: (() => void) | undefined;
    piwik: Piwik | undefined;
};

export const DigitalCardAndPin = ({
    dictionary,
    piwik,
    isMobile,
    onDigitalCardClick,
    onSeePinClick,
}: DigitalCardAndPinProps) => {
    const showDigitalCardClick = !!onDigitalCardClick;
    const showSeePinClick = !!onSeePinClick;

    if (!showDigitalCardClick && !showSeePinClick) {
        return null;
    }

    return (
        <div className="card-control-panel__buttons-container">
            {showDigitalCardClick && (
                <Button
                    data-track-id={piwik?.cardDetails?.digitalCard?.dataTrackId}
                    data-track-linkname={piwik?.cardDetails?.digitalCard?.dataTrackLinkname}
                    id={piwik?.cardDetails?.digitalCard?.dataTrackId}
                    onClick={onDigitalCardClick}
                    type="button"
                    size="small"
                    buttonType={isMobile ? ButtonTypes.SMALL_POSITIVE : ButtonTypes.STANDARD_POSITIVE}
                >
                    {dictionary.digitalCardTitle}
                </Button>
            )}
            {showSeePinClick && (
                <Button
                    data-track-id={piwik?.cardDetails?.cardFunctionalityButtonVisPIN?.dataTrackId}
                    data-track-linkname={piwik?.cardDetails?.cardFunctionalityButtonVisPIN?.dataTrackLinkname}
                    id="show-pin"
                    onClick={onSeePinClick}
                    type="button"
                    size="small"
                    buttonType={isMobile ? ButtonTypes.SMALL_NEGATIVE : ButtonTypes.STANDARD_NEGATIVE}
                >
                    {dictionary.pinViewText}
                </Button>
            )}
        </div>
    );
};
